import React from "react";
import { Checkbox, Label, Slider } from "@fluentui/react-components";
import { type ChartStyleSectionProps, useSliderStyles } from "./shared";

const PieStyle: React.FC<ChartStyleSectionProps> = ({ chartStyle: cs, onStyleChange }) => {
  const styles = useSliderStyles();
  return (
    <>
      <Checkbox
        label="Donut (hollow center)"
        checked={cs.donut ?? true}
        onChange={(_, data) => onStyleChange({ donut: !!data.checked })}
      />
      {(cs.donut ?? true) && (
        <div className={styles.sliderField}>
          <Label size="small">Inner Radius</Label>
          <div className={styles.sliderRow}>
            <Slider
              min={0} max={80} step={5}
              value={cs.innerRadius ?? 40}
              onChange={(_, data) => onStyleChange({ innerRadius: data.value })}
              style={{ flex: 1 }}
            />
            <span className={styles.sliderValue}>{cs.innerRadius ?? 40}%</span>
          </div>
        </div>
      )}
      <div className={styles.sliderField}>
        <Label size="small">Outer Radius</Label>
        <div className={styles.sliderRow}>
          <Slider
            min={50} max={100} step={5}
            value={cs.outerRadius ?? 70}
            onChange={(_, data) => onStyleChange({ outerRadius: data.value })}
            style={{ flex: 1 }}
          />
          <span className={styles.sliderValue}>{cs.outerRadius ?? 70}%</span>
        </div>
      </div>
      <Checkbox
        label="Sort slices by value"
        checked={cs.sortSlices ?? false}
        onChange={(_, data) => onStyleChange({ sortSlices: !!data.checked })}
      />
    </>
  );
};

export default PieStyle;